/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { isAliveGet } from '../fn/ping/is-alive-get';
import { IsAliveGet$Params } from '../fn/ping/is-alive-get';
import { isAliveHead } from '../fn/ping/is-alive-head';
import { IsAliveHead$Params } from '../fn/ping/is-alive-head';

@Injectable({ providedIn: 'root' })
export class PingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `isAliveGet()` */
  static readonly IsAliveGetPath = '/api/Ping/IsAlive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isAliveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  isAliveGet$Response(params?: IsAliveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return isAliveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `isAliveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  isAliveGet(params?: IsAliveGet$Params, context?: HttpContext): Observable<void> {
    return this.isAliveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `isAliveHead()` */
  static readonly IsAliveHeadPath = '/api/Ping/IsAlive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isAliveHead()` instead.
   *
   * This method doesn't expect any request body.
   */
  isAliveHead$Response(params?: IsAliveHead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return isAliveHead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `isAliveHead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  isAliveHead(params?: IsAliveHead$Params, context?: HttpContext): Observable<void> {
    return this.isAliveHead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
